// extracted by mini-css-extract-plugin
export default {"container":"sJm88Z"};